import { useDetectChannelId } from '@/features/Channels/hooks/useDetectChannelId';

import { useIsCommentsFeed } from './useIsCommentsFeed';

export const useCanAccessComments = () => {
  const { channelId } = useDetectChannelId();

  const { isGlobalComments } = useIsCommentsFeed();
  return !!(channelId || isGlobalComments);
};
